<template lang="pug">
.mg-popup__container
  .mg-popup__title {{ $t(`popup.${popup}.title`) }}
  .mg-popup__text {{ $t(`popup.${popup}.text`) }}
  .mg-popup__item 
    img.mg-popup__card(v-for="index in 5", :key="index", :src="getCardImgSrc(index)")
  .mg-popup__buttons
    button.button.button-medium-x15(@click="handleConfirm")
      span {{ $t(`popup.upgrade`) }}
    button.button.button-medium-x15(@click="closePopup")
      span {{ $t(`popup.close`) }}

</template>

<script>
const SUPERPRIZE_LEVEL = 6;
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";

import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapState, mapGetters } = createNamespacedHelpers(mg_global);

export default {
  name: "GetPrizePopup",

  data() {
    return {
      in_progress: false,
    };
  },

  computed: {
    ...mapState(["popup", "current_row"]),
    ...mapGetters(["getPrizesList", "getCardsList", "getMaxShardsCount"]),
  },

  methods: {
    getCardImgSrc(index) {
      return require(`@/assets/game/images/cards/card_row${this.current_row}_${index}.png`);
    },

    closePopup() {
      this.$emit("closePopup");
    },

    handleConfirm() {
      if (this.in_progress) return false;

      this.in_progress = true;
      this.$store
        .dispatch(`${mg_global}/upgradeCards`)
        .then(response => {
          if (response.level === SUPERPRIZE_LEVEL) {
            this.$store.dispatch(`${mg_global}/getProgress`);
          } else {
            this.$store.commit(`${mg_global}/setNewCard`, response);
          }
          return response;
        })
        .then(response => {
          if (response.level === SUPERPRIZE_LEVEL) {
            if (response.amount === this.getMaxShardsCount) {
              this.$store.commit(`${mg_global}/setCurrentRow`, 6);
              this.$store.commit(`${mg_global}/setCurrentReward`, this.getPrizesList.superprize);
              this.$store.commit(`${mg_global}/setPopup`, "reward_superprize");
            } else {
              this.closePopup();
            }
          } else {
            this.$store.commit(`${mg_global}/removeRow`);
            this.$store.commit(`${mg_global}/setPopup`, "new_card");
          }
        })

        .catch(error => {
          this.$notify({
            type: "error",
            closeOnClick: "true",
            duration: 5000,
            group: "collection",
            position: "bottom right",
            text: this.$t(`error.${error.message}`),
          });
          this.$store.commit(`${mg_global}/placeRow`);
        })
        .finally(() => {
          this.in_progress = false;
        });
    },
  },
};
</script>
